import { createContext } from 'react'
export const StillAlbumContext = createContext()
